<template>
  <div id="app" class="main-app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex'
import { isAuthError, isNetworkError, isPublicAuthRoute, routeRequiresAuth } from '@/lib/auth'

export default {
  name: 'App',
  beforeMount() {
    this.loadMe()
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  methods: {
    ...mapMutations(['logout']),
    loadMe() {
      const path = this.$route.path
      const isPublic = isPublicAuthRoute(path)

      if (!this.isAuthenticated) {
        if (!isPublic && routeRequiresAuth(this.$route)) {
          this.$router.push('/login')
        }
        return
      }

      this.$apollo.query({
        query: gql`query {
          me {
            id
            name
            email
          }
        }`,
        fetchPolicy: 'no-cache',
      })
        .then(() => {
          // sesión válida
        })
        .catch((error) => {
          if (isAuthError(error)) {
            this.$router.push('/logout')
            return
          }

          if (isNetworkError(error) && !isPublic) {
            this.$toast.warning('No se pudo verificar la sesión. Si persiste, recargá la página.')
          }
        })
    },
  },
}
</script>
